import { Stack, Text, RichTextContent } from '@etg/wings';
import { css } from '@eti/styles';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const richTextStyles = css`
  font-size: 0.875rem;

  li::before {
    content: none;
    display: none;
  }
`;
const TicketDetailsSection = ({
  content,
  title
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [title && /*#__PURE__*/_jsxs(Text, {
    "data-testid": "drawer-ticket-section-title",
    children: [title, ":"]
  }), Array.isArray(content) && content.length > 0 ? /*#__PURE__*/_jsx(RichTextContent, {
    className: richTextStyles,
    "data-testid": "drawer-ticket-section-list",
    children: /*#__PURE__*/_jsx(Stack, {
      as: "ul",
      role: "list",
      spacing: 0,
      children: content.map((item, index) => /*#__PURE__*/_jsx(Text, {
        as: "li",
        children: item
      }, index))
    })
  }) : /*#__PURE__*/_jsx(RichTextContent, {
    className: richTextStyles,
    "data-testid": "drawer-ticket-section-plain-text",
    children: content
  })]
});
export default TicketDetailsSection;
//# sourceMappingURL=TicketDetailsSection.js.map